export default __webpack_public_path__ + "assets/images/cdf37184ace23ce6fe2a8dd2573481ff.svg";